// Which vehicles each product fits — drives "Shop by vehicle" and the shop's Vehicle filter.
// Keys match the tune builder: vq35 = 350Z/G35 2003–2008 · g37_08 = 2008 G37 · vq37 = 370Z/G37/Q40/M37/3.7L Q50-Q60 (2009+)
// vr30 = Q50/Q60 3.0T · z = 2023+ Nissan Z · gtr = R35 GT-R · bmw = BMW B58/S58 · "*" = universal (fits everything).
// suv35 / suv37 = Infiniti VQ SUVs (FX35/EX35 2004–2008 ECU · FX35/FX37/EX35/EX37/QX50/QX70 2009+ ECU): tunes & services only.
// Built from the product titles & options. On Shopify these become product tags (e.g. fits-vq37) the owner edits in the admin.
// Parts may list MODEL IDS (the last column of assets/vehicles.js) instead of a platform: one exact car each
// (per-model VQ fitment, owner 2026-11-01). Tunes and services keep their platform keys.
window.AT_FIT = {
"admintuning-gtr-performance-package-intermediate-level": [
"gtr"
],
"total-racing-products-mission-control-canbus-flexfuel-complete-power-management": [
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37"
],
"admintuning-infiniti-g37-nissan-370z-3-long-tube-intake-system": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"g35s_hr"
],
"admintuning-gtr-performance-package-street-level": [
"gtr"
],
"total-racing-products-eca-plus-canbus-flexfuel-kit-with-3-sensor-inputs-nissan-370z-infiniti-g37": [
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37"
],
"cj-motorsports-cjm-twin-pump-for-infiniti-g37": [
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"admintuning-vr30-performance-package-elite-level": [
"vr30",
"z"
],
"admintuning-billet-pro-e85-conversion-kit-nissan-infiniti-350z-370z-g35-g37": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"admintuning-e85-conversion-kit": [
"350z_de",
"g35c",
"g35s_de",
"350z_hr",
"g35s_hr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37",
"q70"
],
"cjm-s1-vq35de-fuel-return-system-with-pressure-gauge": [
"350z_de",
"g35c",
"g35s_de"
],
"admintuning-uprev-remote-tune-2003-2008-nissan-infiniti": [
"vq35",
"g37_08",
"suv35"
],
"total-racing-products-trp-fuel-pump-hardwire-kit": [
"*"
],
"admintuning-e85-conversion-kit-tuning-package": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37",
"q70",
"g35c",
"g35s_de",
"g35s_hr"
],
"cj-motorsports-s1-e-fuel-return-system-370z-g37-q50-3-7l": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"admintuning-vr30-performance-package-street-level": [
"vr30",
"z"
],
"admintuning-pnp-fuel-pressure-monitoring-kit-for-vq37-with-ecutek-copy": [
"gtr"
],
"total-racing-products-150psi-pressure-sensor": [
"*"
],
"pcv-delete-open-breather-kit-infiniti-g37-nissan-370z": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"admintuning-cold-air-intakes-tuning-package": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"g35s_hr"
],
"boosted-performance-mid-mount-single-turbocharger-kit-infiniti-g37-nissan-370z": [
"350z_de",
"350z_hr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"cjm-fuel-return-system-s1se-nissan-370z-infiniti-g37-infiniti-q50-q60": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"injector-dynamics-id1300x-1300cc-min-fuel-injectors-w-plug-play": [
"gtr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37",
"q70"
],
"admintuning-3-long-tube-intake-elite-titanium-edition-nissan-370z-infiniti-g37": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"g35s_hr"
],
"admintuning-cold-air-intakes-e85-conversion-kit-tuning-package": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q60_37",
"g35s_hr"
],
"admintuning-650cc-min-fuel-injectors-plug-play": [
"350z_de",
"g35c",
"g35s_de",
"350z_hr",
"g35s_hr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"ecutek-boost-management-kit": [
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37",
"suv37"
],
"cj-motorsports-cjm-twin-pump-for-nissan-350z": [
"350z_de",
"g35c",
"g35s_de",
"350z_hr",
"g35s_hr"
],
"trp-pnp-fuel-coolant-oil-pressure-sensor-kit-2009-370z-gtr-g37-q50-q60-copy": [
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"total-racing-products-flex-fuel-kit-for-mhd-and-ecutek-bmw-b58-s58": [
"bmw"
],
"admintuning-ecutek-remote-tuning-kit-boost-nissan-infiniti-2003-2008-vq35-vq37": [
"vq35"
],
"total-racing-products-pnp-o2-input-kit-for-ecutek-2009-370z-g37-q50-q60": [
"gtr",
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"admintuning-vr30-performance-package-pro-level-q50-q60-23-z": [
"vr30",
"z"
],
"greddy-profec-boost-controller-15500214": [
"350z_de",
"g35c",
"g35s_de",
"350z_hr",
"g35s_hr",
"g37c_08"
],
"total-racing-products-nissan-infiniti-vq37-flexfuel-kit-forced-induction": [
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"unknown-performance-2009-370z-2008-g37-600whp-package-6mt-only": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"admintuning-ecutek-remote-tuning-kit-2023-nissan-z-vr30-3-0t": [
"z"
],
"admintuning-ecutek-remote-tune-2009-nissan-infiniti-vq37": [
"vq37",
"suv37"
],
"admintuning-gtr-performance-package-ultimate-level-max-stock-engine-trans": [
"gtr"
],
"admintuning-ecutek-remote-tune-nissan-r35-gtr": [
"gtr"
],
"unknown-performance-midmount-turbo-kit-nissan-370z-infiniti-g37": [
"350z_de",
"350z_hr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"cjm-s0-vq35hr-fuel-return-system-with-pressure-gauge": [
"350z_hr",
"g35s_hr"
],
"injector-dynamics-id1050x-1050cc-min-fuel-injectors-w-plug-play": [
"gtr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37",
"q70"
],
"current-customer-retunes-nitrous-tuning": [
"vq35",
"g37_08",
"vq37",
"vr30",
"z",
"suv35",
"suv37"
],
"admintuning-closed-deck-vq37-engine-packages-short-block-370z-g37": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"total-racing-products-5-bar-map-sensor-conversion-kit-2009-nissan-infiniti": [
"gtr",
"370z",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"q50_37"
],
"turbosmart-eboost2-electronic-boost-controller-2003-2008-nissan-infiniti": [
"350z_de",
"g35c",
"g35s_de",
"350z_hr",
"g35s_hr",
"g37c_08"
],
"walbro-hellcat-525lph-fuel-pump-f90000285": [
"*"
],
"current-customer-retunes-naturally-aspirated": [
"vq35",
"g37_08",
"vq37",
"suv35",
"suv37"
],
"total-racing-products-ultimate-fuel-pump-hardwire-kit-w-cowl-shield-r35-gtr": [
"gtr"
],
"admintuning-ecutek-boosted-remote-tuning-kit-nissan-infiniti-vq37vhr": [
"vq37",
"suv37"
],
"unknown-performance-2007-2008-350z-600whp-package-6mt-only": [
"350z_hr"
],
"admintuning-ecutek-remote-tuning-kit-2003-2008-nissan-infiniti-vq35-vq37": [
"vq35"
],
"admintuning-ecutek-transmission-tune-vr30-transmission-tcm": [
"vr30"
],
"total-racing-products-flex-fuel-kit-for-ecutek-r35-gtr": [
"gtr"
],
"total-racing-products-speed-density-kit-r35-gtr": [
"gtr"
],
"admintuning-closed-deck-vq37-engine-packages-long-block-370z-g37": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37"
],
"admintuning-ecutek-remote-tune-2016-2023-nissan-infiniti-vr30-3-0t": [
"vr30"
],
"tune-migration-service-current-customer-ecus": [
"vq35",
"g37_08",
"vq37",
"vr30",
"z",
"gtr",
"suv35",
"suv37"
],
"current-customer-retunes-forced-induction-currently-boosted": [
"vq35",
"g37_08",
"vq37",
"vr30",
"z",
"suv35",
"suv37"
],
"ecutek-custom-adjustable-traction-control-na-forced-induction": [
"vq37",
"vr30",
"z",
"gtr",
"suv37"
],
"total-racing-products-3-intake-kit-r35-gtr": [
"gtr"
],
"admintuning-merch-pack-v1-license-plate-frame-decal-air-freshener": [
"*"
],
"unknown-performance-midmount-twin-turbo-kit-6mt-370z-g37": [
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q60_37"
],
"cjm-twin-pump-for-2009-nissan-370z": [
"370z"
],
"admintuning-license-plate-frame": [
"*"
],
"bmw-dme-ecutek-unlock-service-mail-in-pre-june-2020-supra-b58-and-x3m-s58": [
"bmw"
],
"admintuning-pnp-coolant-pressure-monitoring-kit-for-vq37-with-ecutek-copy": [
"gtr"
],
"current-customer-retunes-forced-induction-going-from-na-to-boost": [
"vq35",
"g37_08",
"vq37",
"suv35",
"suv37"
],
"bmw-dme-ecutek-unlock-service-mail-in-post-june-2020-supra-b58-g8x-m3-m4-x3m-s58": [
"bmw"
],
"current-customer-retunes-vr38dett-r35-gtr": [
"gtr"
],
"admintuning-g37-supercharger-t-shirt-2025": [
"*"
],
"total-racing-products-speed-density-kit-r35-gtr-copy": [
"gtr"
],
"total-racing-products-r-switch-2-0-restore-your-leds-and-add-switch-memory-r35-gtr": [
"gtr"
],
"total-racing-products-trp800-turbo-kit-r35-gtr-1": [
"gtr"
],
"injector-dynamics-id1700x-1700cc-min-fuel-injectors-w-plug-play": [
"gtr",
"370z",
"g37c_08",
"g37c",
"g37s",
"g37v",
"q40",
"q60_37",
"m37",
"q50_37",
"q70"
],
"ecutek-ecu-connect-programming-kit": [
"vq35",
"vq37",
"vr30",
"z",
"gtr",
"suv37"
],
"ams-performance-red-alpha-race-heat-exchanger-2016-infiniti-q50-q60": [
"vr30"
],
"ams-performance-nissan-z-heat-exchanger-nissan-z-rz34": [
"z"
],
"ams-performance-vr30ddtt-race-lower-downpipes-infiniti-q50-q60-nissan-z-rz34": [
"vr30",
"z"
],
"ams-performance-infiniti-q50-q60-red-alpha-cold-air-intake-kit": [
"vr30"
],
"ams-performance-nissan-z-cold-air-intakes-nissan-rz34": [
"z"
],
"ams-performance-canbus-flexfuel-kit-infiniti-q50-q60-nissan-z-rz34": [
"vr30",
"z"
],
"ams-performance-vr30ddtt-low-pressure-fuel-pump": [
"vr30",
"z"
],
"ams-performance-vr30ddtt-stage-1-high-pressure-fuel-pump-infiniti-q50-q60-nissan-z-rz34": [
"vr30",
"z"
],
"ams-performance-vr30ddtt-stage-1-direct-injectors": [
"vr30",
"z"
],
"ams-performance-in-tank-fuel-pump-system-twin-lpfp-infiniti-q50-q60-nissan-z-rz34": [
"vr30",
"z"
],
"ams-performance-vr30ddtt-stage-3-high-pressure-fuel-pump-infiniti-q50-q60-nissan-z-rz34": [
"vr30",
"z"
],
"ams-performance-vr30ddtt-stage-3-direct-injectors-2016-infiniti-q50-q60-nissan-rz34": [
"vr30",
"z"
]
};
